import React from 'react';
import LogoLight from '../assets/hero_logo.png';

const LottiPlayer = () => {
  return <img src={LogoLight} alt='ELE logo' />;
};

export default LottiPlayer;
